import React from 'react';

const GoogleIcon: React.FC = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.3981 9.20051C17.3981 8.58019 17.3425 7.98373 17.2391 7.41113H9V10.795H13.708C13.5052 11.8885 12.8889 12.815 11.9624 13.4354V15.6303H14.7896C16.4438 14.1074 17.3981 11.8647 17.3981 9.20051Z"
      fill="#4285F4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.00072 17.7431C11.3627 17.7431 13.3429 16.9598 14.7903 15.6237L11.9631 13.4288C11.1798 13.9536 10.1777 14.2638 9.00072 14.2638C6.72225 14.2638 4.7937 12.7249 4.10578 10.6572H1.18314V12.9238C2.62259 15.7828 5.58102 17.7431 9.00072 17.7431Z"
      fill="#34A853"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.10507 10.665C3.93011 10.1401 3.8307 9.57946 3.8307 9.00289C3.8307 8.42631 3.93011 7.86564 4.10507 7.34076V5.07422H1.18243C0.589946 6.25521 0.251953 7.59127 0.251953 9.00289C0.251953 10.4145 0.589946 11.7506 1.18243 12.9316L4.10507 10.665Z"
      fill="#FBBC05"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.00071 3.73129C10.2851 3.73129 11.4382 4.17267 12.3449 5.03952L14.854 2.53042C13.339 1.1188 11.3587 0.251953 9.00071 0.251953C5.58102 0.251953 2.62259 2.21231 1.18314 5.07133L4.10578 7.33787C4.7937 5.27015 6.72225 3.73129 9.00071 3.73129Z"
      fill="#EA4335"
    />
  </svg>
);

export default GoogleIcon;
